import axios from 'axios';

const API_URL = 'http://localhost:40321/api';
//const API_URL = 'http://2.56.29.252:8080/api';
//const API_URL = 'https://ahnlundconsulting.se:8090/api';


class AuthService {
  login(user) {
    return axios
      .post(API_URL + '/signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('/user');
  }

  register(user) {
    return axios.post(API_URL + '/signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();